const REFERENCE_INDEX_HEADING = "Reference Index";

export const definitions = {
  headings: {
    explanation: "Explanation of Portfolios",
    keyTerms: "Key Terms",
    generalDefinitions: "General Definitions",
    referenceIndex: REFERENCE_INDEX_HEADING,
    styleRiskDefinitions: "Style Risk Exposures Definitions",
    indexDescriptions: "Index Descriptions",
  },
  taxLiability: {
    title: "Minimize Tax Liability",
    explanation:
      "Portfolio with high tracking error relative to the representative benchmark portfolio but will lead to lower tax cost during transition",
  },
  balance: {
    title: "Balance Tax Liability & Tracking Error",
    explanation:
      "Portfolio with medium tracking error relative to the representative benchmark portfolio but will lead to medium tax cost during transition",
  },
  minTrackingError: {
    title: "Minimize Tracking Error",
    explanation:
      "Portfolio with low tracking error relative to the representative benchmark portfolio but will lead to higher tax cost during transition",
  },
  portfolio: {
    term: "Portfolio",
    definition: "Portfolio constructed from cash",
  },
  currentPortfolio: {
    term: "Current Portfolio",
    definition: "The prospective client's existing portfolio",
  },
  reinvestProceeds: {
    term: "Maintain & Re-Invest Proceeds",
    definition:
      "Migrate the current portfolio to ladder by re-investing the future proceeds from exiting positions",
  },
  referenceIndex: {
    fixedIncome: {
      term: REFERENCE_INDEX_HEADING,
      definition: "Bloomberg Barclays Municipal Short/Intermediate 1-10 yr",
    },
    shortTreasury: {
      term: REFERENCE_INDEX_HEADING,
      definition: "Bloomberg Short Treasury",
    },
    treasury: {
      term: REFERENCE_INDEX_HEADING,
      definition: "Bloomberg US Treasury 1-3 Yr",
    },
    equity: {
      term: REFERENCE_INDEX_HEADING,
      definition: "S&P 500",
    },
  },
  benchmark: {
    cash: {
      term: "Benchmark",
      definition: "Same as reference index",
    },
    transition: {
      term: "Benchmark",
      definition: "S&P 500 Index",
    },
  },
  targetPortfolio: {
    term: "Target Portfolio",
    definition: "Target portfolio constructed from cash",
  },
  betaToIndex: {
    term: "Beta to Index",
    definition:
      "A measure of the volatility (systematic risk) of a security or portfolio compared to the reference index.",
  },
  bloombergBlendOneToFive: {
    term: "Bloomberg 1-5 Yr. Blend (1-6)",
    definition:
      "The Bloomberg 1-5 Year Blend (1-6) Municipal Bond Index is the 1-5 year component of the Bloomberg Municipal Bond Index. The Bloomberg Municipal Bond Index is an unmanaged Index composed of long-tern tax-exempt bonds with minimum credit rating of Baa. You cannot invest directly in an index.",
  },
  bloombergBlendThreeToFifteen: {
    term: "Bloomberg 3-15 Yr. Blend (2-17)",
    definition:
      "The Bloomberg 3-15 Yr. Blend is the 3-15 year component of the Bloomberg Municipal Bond index. The Bloomberg Municipal Bond index is an unmanaged Index composed of long-term tax exempt bonds with a minimum credit rating of Baa. You cannot invest directly in an index.",
  },
  bloombergMunicipal: {
    term: "Bloomberg Municipal Shohrt/Intermediate 1-10 Yr.",
    definition:
      "The Bloomberg Short-Intermediate Municipal Bond index is a rules-based, market-value weighted index composed of publicly traded municipal bonds that cover the U.S. Dollar denominated short-term tax-exempt bond market, including state and local general obligation bonds, revenue bonds, and pre-refunded bonds. You cannot invest directly in an index.",
  },
  bloombergShortTreasury: {
    term: "Bloomberg Short Treasury",
    definition:
      "The Bloomberg Short Treasury Index is an unmanaged index composed of U.S Treasury bills, notes, and bonds with maturities of 0 to 1 year. You cannot invest directly in an index.",
  },
  bloombergUsCorporate: {
    term: "Bloomberg US Corporate 1-5 Yr.",
    definition:
      "The Bloomberg US Corporate Index 1-5 year is an unmanaged market valued weighted index of taxable investment grade corporate fixed rate debt issues with maturities of 1 year to 5 years. You cannot invest directly to an index.",
  },
  bloombergUsTreasury: {
    term: "Bloomberg US Treasury",
    definition:
      "1-3 Yr. Index Bloomberg US Treasury 1-3 Yr. Index is an unmanaged index composed of U.S Treasury bonds with maturities of 1 to 3 years. You cannot invest directly in an index.",
  },
  bloombergUsIntermediateCorporate: {
    term: "Bloomberg Barclays US Intermediate Corporate Index (RET)",
    definition:
      "The Bloomberg Barclays US Intermediate Corporate Index is an unmanaged market valued weighted index of taxable investment grade corporate fixed rate debt issues with maturities of 1 year to 9.9999 years. You cannot invest directly to an index.",
  },
  bloombergUsIntermediateTreasury: {
    term: "Bloomberg US Intermediate Treasury Index",
    definition:
      "The Bloomberg U.S Intermediate Treasury Index is an unmanaged index composed of U.S Treasury bonds with maturities of 1 to 10 years. You cannot invest directly in an index.",
  },
  callable: {
    term: "Callable",
    definition:
      "A security that is subject to early redemption through a call provision, excluding extraordinary redemptions, sinking fund redemptions, or make-whole call redemptions.",
  },
  coupon: {
    term: "Coupon",
    definition:
      "The periodic interest payment a bond issuer makes to a bond holder, normally expressed as a percentage of par.",
  },
  couponTransition: {
    term: "Coupon",
    definition:
      "The yield paid by the security; the annual interest rate paid on a bond expressed as a percentage of the face value.",
  },
  creditQuality: {
    term: "Credit Quality",
    definition: (
      <>
        Assessment of creditworthiness of a borrower; based on the number of
        outstanding debts and timeliness of past debt repayments.
        <br />
        The ratings indicated are from Standard & Poor’s, Moody’s Investors
        Service, and/or Fitch Ratings Ltd. Credit-quality ratings: Standard &
        Poor's rates the creditworthiness of bonds from AAA (highest) to D
        (lowest). Ratings from A to CCC may be modified by the addition of a
        plus (+) or minus (-) sign to show relative standing within the rating
        categories. Moody’s rates the creditworthiness of bonds from Aaa
        (highest) to C (lowest). Ratings Aa to B may be modified by the addition
        of a number 1 (highest) to 3 (lowest) to show relative standing within
        the ratings categories. Fitch rates the creditworthiness of bonds from
        AAA (highest) to D (lowest).
      </>
    ),
  },
  durationTimeSpread: {
    term: "Duration Times Spread (DTS)",
    definition:
      "The market standard method for measuring the credit volatility of a corporate bond. It is calculated by simply multiplying two readily available bond characteristics: the spread-duration and the credit spread.",
  },
  effectiveDuration: {
    term: "Effective Duration",
    definition:
      "Duration calculation for bonds that have embedded options. This measure of duration takes into account the fact that expected cash flows will fluctuate as interest rates change and is, therefore, a measure of risk.",
  },
  esgRating: {
    term: "ESG Rating",
    definition: (
      <>
        Measure a company’s resilience to long-term, industry material
        environmental, social and governance (ESG) risks (from MSCI). Reference:
        <a
          href="https://www.msci.com/our-solutions/esg-investing/esg-ratings"
          target="_blank"
          rel="noreferrer"
        >
          https://www.msci.com/our-solutions/esg-investing/esg-ratings
        </a>
      </>
    ),
  },
  exAnteTrackingError: {
    term: "Ex Ante Tracking Error",
    definition:
      "The difference in risk between a managed portfolio and a specified benchmark, measured as the expected standard deviation of the differential return bbetween the portfolio and an equal investment in the bbenchmark.",
  },
  explanationAllspringViews: {
    heading: "",
    description: (
      <>
        <p>
          Allspring views the Minimize Tax Liability and Minimize Tracking Error
          portfolios as the end point of a spectrum of alternative portfolios.
          The Minimize Tax Liability portfolio represents the alternative having
          the minimum tax liability, but the greatest risk. The Minimize
          Tracking Error portfolio represents the alternative having the minimum
          risk, but the maximum tax liability. Allspring stands ready to
          implement any portfolio between the Minimize Tax Liability portfolio
          and the Minimize Tracking Error portfolio that suits the prospective
          client's aversion to taxes and tolerance for risk. Allspring
          recommends the Balanced Tracking Error & tax Liability portfolio,
          which lies somewhere in the middle of the spectrum and represents a
          reasonable trade-off between tax liability and risk.
        </p>
      </>
    ),
  },
  keyRateDuration: {
    term: "Key Rate Duration (KRD)",
    definition:
      "Measures the duration of a portfolio at a specific maturity point along the entire yield curve.",
  },
  liquidityScore: {
    term: "Liquidity Score (LQA)",
    definition:
      "Measures how easily a security can be sold without having to lower its price to a significant degree or bought without having to increase its price to a significant degree; determines the degree to which a security can be rapidly transacted at a reasonable size with little price impact.",
  },
  maturityDate: {
    term: "Maturity Date",
    definition:
      "Date in which the security's principal amount becomes due; Time to maturity (what's bucketed in the Maturity tab) is how much time (in years) until that date.",
  },
  model: {
    term: "Model",
    definition:
      "Par Value Money amount the bond will be worth at maturity and the reference notional amount the bond issuer uses when calculating interest payments.",
  },
  modelTPlan: {
    term: "Model",
    definition:
      "The Model Portfolio consists of securities pre-selected to achieve certain characteristics with a corresponding risk which is representative of the strategy. This portfolio is guaranteed to be investable and is not actively managed.",
  },
  optionAdjustedSpread: {
    term: "Option Adjusted Spread (OAS)",
    definition:
      "The yield spread which has to be added to a benchmark yield curve to discount a security's payments to match its market price, using a dynamic pricing model that accounts for embedded options.",
  },
  optionAdjustedSpreadDuration: {
    term: "Option Adjusted Spread Duration (OASD)",
    definition:
      "Measures the sensitivity of a bond's price to changes in credit spread.",
  },
  parValue: {
    term: "Par Value",
    definition:
      "Money amount the bond will be worth at maturity and the reference notional amount the bond issuer uses when calculating interest payments.",
  },
  price: {
    term: "Price",
    definition:
      "Price at which the buyer purchases the bond, including accrued interest.",
  },
  timeToMaturity: {
    term: "Time to Maturity",
    definition: "Number of years from today to maturity.",
  },
  trackingError: {
    term: "Tracking Error",
    definition:
      "The difference in actual performance between a position (usually an entire portfolio) and its corresponding target portfolio.",
  },
  yieldToMaturity: {
    term: "Yield to Maturity",
    definition:
      "The internal rate of return earned by an investor who buys the bond today at the market price, assuming that the bond is held until maturity, and that all coupon and principal payments are made on schedule.",
  },
  yieldToWorst: {
    term: "Yield to Worst",
    definition:
      "Measure of the lowest possible yield that can be received within terms of contract without defaulting.",
  },
  transitionSummary: {
    heading: "Transition Summary Explanation",
    description: (
      <>
        <p>
          Investors seeking to transition their existing portfolio in-kind to a
          new managed strategy should be aware of tax liability and risk
          implications. Providing various transition options to reduce risk gap
          (i.e. tracking error) between client's current portfolio and target
          strategy while minimizing tax drag is the primary objective of
          transition analysis. This summary highlights the various
          implementation choices by showcasing the trade-offs across two
          critical factors - one, tracking error, a measure of closeness of
          client portfolio to target portfolio; and two, tax liability, the tax
          cost of realizing any embedded capital gains in the client portfolio
          during the transition. By reviewing these various implementation
          choices and understanding the trade-offs between tracking error and
          tax liability, an FA and their client can then make an informed
          decision on how to transition their portfolio to the new strategy in
          an optimal way that suits their needs.
        </p>
        <p>
          The total cost basis for each security position and the unrealized
          gain/loss are provided solely for your convenience and may not be used
          for tax purposes or otherwise relied upon. Tax calculations are only
          provided for your convenience and should not be relied on for tax
          purposes. Please consult your tax advisor for questions related to the
          tax treatment of your investments. Unrealized gain/loss are based on
          cost basis as provided as is.
        </p>
      </>
    ),
  },
  footnote: {
    transition: {
      corp: (
        <>
          *The corporate securities are drawn from a broader universe of
          securities that have certain predefined characteristics (i.e.
          duration, rating etc.). The broader universe of securities consists of
          securities that are in the representative model portfolio, are
          actively monitored by the global credit research team, and that are
          part of the broader corporate reference index.
        </>
      ),
      treasury: (
        <>
          *The treasury securities are drawn from a broader universe of
          securities that have certain predefined characteristics (i.e.
          duration, rating etc.). The broader universe of securities consists of
          securities that are in the representative model portfolio, are
          actively monitored by the global credit research team, and that are
          part of the broader treasury reference index.
        </>
      ),
      muni: (
        <>
          *The muni securities are drawn from a broader universe of securities
          that have certain predefined characteristics (i.e. duration, rating
          etc.). The broader universe of securities consists of securities that
          are in the representative model portfolio, are actively monitored by
          the muni research team, and that are part of the broader muni
          reference index.
        </>
      ),
    },
    cash: (
      <>
        *Existing portfolio information is based on information provided in the
        input questionnaire for the transition analysis.
        <br />
        **The proposed portfolios and models are not maintained as live
        composites or portfolios at Allspring Global Investments. They are for
        illustrative purposes only to demonstrate our investment capabilities.
        The holdings used in the report is a representative portfolio and does
        not represent actual holdings in a live portfolio. The information shown
        is not intended to be, nor should it be construed to be, a
        recommendation to buy or sell an individual security.
      </>
    ),
  },
  table: {
    creditQuality: {
      term: "Credit Quality Buckets",
      definition: "",
      tableContent: {
        columns: [
          {
            label: "AAA",
            key: "aaa",
          },
          {
            label: "AA",
            key: "aa",
          },
          {
            label: "A",
            key: "a",
          },
          {
            label: "BBB",
            key: "BBB",
          },
          {
            label: "BB",
            key: "bb",
          },
          {
            label: "B",
            key: "b",
          },
          {
            label: "CCC",
            key: "ccc",
          },
          {
            label: "CC",
            key: "cc",
          },
          {
            label: "C",
            key: "c",
          },
          {
            label: "D",
            key: "D",
          },
          {
            label: "NR",
            key: "nr",
          },
        ],
        lists: [
          {
            aaa: "AAA",
            aa: "AA1",
            a: "A1",
            bbb: "BAA1",
            bb: "BA1",
            b: "B1",
            ccc: "CAA1",
            cc: "CA",
            c: "C",
            d: "D",
            nr: "NR",
          },
          {
            aaa: "",
            aa: "AA2",
            a: "A2",
            bbb: "BAA2",
            bb: "BA2",
            b: "B2",
            ccc: "CAA2",
            cc: "",
            c: "",
            d: "",
            nr: "",
          },
          {
            aaa: "",
            aa: "AA3",
            a: "A3",
            bbb: "BAA3",
            bb: "BA3",
            b: "B3",
            ccc: "CAA3",
            cc: "",
            c: "",
            d: "",
            nr: "",
          },
        ],
      },
    },
    esgRating: {
      term: "ESG Rating Buckets",
      definition: "",

      tableContent: {
        columns: [
          {
            label: "AAA",
            key: "aaa",
          },
          {
            label: "AA",
            key: "aa",
          },
          {
            label: "A",
            key: "a",
          },
          {
            label: "BBB",
            key: "BBB",
          },
          {
            label: "BB",
            key: "bb",
          },
          {
            label: "B",
            key: "b",
          },
          {
            label: "CCC",
            key: "ccc",
          },
        ],
        columnContent: [
          {
            title: "Leader",
            description:
              "A company leading its industry in managing the most significant ESG risk and opportunities",
          },
          {
            title: "Average",
            description:
              "A company with a mixed or unexceptional track record of managing the most significant ESG risk and opportunities relative to industry peers",
          },
          {
            title: "Laggard",
            description:
              "A company lagging its industry based on high exposure and managing the most significant ESG risk and opportunities",
          },
        ],
      },
    },
  },
  usBeta: {
    term: "US Beta",
    definition:
      "Captures market risk that cannot be explained by the World factor. The Beta factor is typically the most important style factor. Beta is computed by time-series regression of excess stock returns against the cap-weighted estimation universe.",
  },
  usDividendYield: {
    term: "US Dividend Yield",
    definition:
      "Captures differences in stock returns attributable to stock's trailing 12-month and predicted dividend-to-price ratios",
  },
  usEarningsQuality: {
    term: "US Earnings Quality",
    definition:
      "Explains stock return differences due to the accrual components of earnings.",
  },
  usEarningYield: {
    term: "US Earnings Yield",
    definition:
      "Describes return differences based on a company’s earnings relative to its price. Earnings Yield is considered by many investors to be a strong value signal. The most important descriptor in this factor is the analyst-predicted 12-month earnings-to-price ratio.",
  },
  usEarningsVariability: {
    term: "US Earnings Variability",
    definition:
      "Measures the variability in earnings and cash flows using both historical measures and analyst predictions",
  },
  usGrowth: {
    term: "US Growth",
    definition:
      "Differentiates stocks based on their prospects for sales or earnings growth. The most important descriptor in this factor is the analyst predicted long-term earnings growth. Other descriptors include sales and earnings growth over the trailing five years.",
  },
  usLiquidity: {
    term: "US Liquidity",
    definition:
      "Describes return differences due to relative trading activity. The descriptors for this factor are based on the fraction of total shares outstanding that trade over a recent window.",
  },
  usLeverage: {
    term: "US Leverage",
    definition:
      "Captures return differences between high-leverage and low-leverage stocks. The descriptors within this style factor include market leverage, book leverage, and debt-to-assets ratio",
  },
  usLongTermReversal: {
    term: "US Long-Term Reversal",
    definition:
      "Explains common variation in returns related to long-term stock price behavior",
  },
  usManagementQuality: {
    term: "US Management Quality",
    definition:
      "A combination of asset, investment, net issuance growth measures that captures variation in stock returns of companies experiencing growth or contraction of assets.",
  },
  usMidCapitalization: {
    term: "US Mid Capitalization",
    definition:
      "Explains differences in risk and return for mid-capitalization stocks from small-cap and large-cap stocks.",
  },
  usMomentum: {
    term: "US Momentum",
    definition:
      "Differentiates stocks based on their performance over the trailing 12 months. When computing Momentum exposures we exclude the most recent returns in order to avoid the effects of short-term reversal. The Momentum factor is often the second strongest factor in the model, although sometimes it may surpass Beta in importance.",
  },
  usProfitabitlity: {
    term: "US Profitability",
    definition:
      "Combines profitability measures that characterize efficiency of a firm's operations and total activities",
  },
  usProspect: {
    term: "US Prospect",
    definition:
      "Explains variation in stock returns that have exhibited a lottery-like behavior identified through stock return skewness over a long horizon and drawdown in returns over the recent period.",
  },
  usResidualVolatility: {
    term: "US Residual Volatility",
    definition:
      "Captures relative volatility in stock returns that is not explained by Country and Beta factors",
  },
  usSize: {
    term: "US Size",
    definition:
      "Represents another strong source of equity return covariance, and captures return differences between large-cap stocks and small-cap stocks. We measure Size by the log of market capitalization.",
  },
  usValue: {
    term: "US Value",
    definition:
      "Captures the extent a company is overpriced or underpriced using relative and structural valuation metrics.",
  },
};

export const equityDefinitions = {
  costBasis: {
    term: "Cost Basis",
    definition:
      "Original price paid to purchase securities plus other costs such as commissions or other transaction fees",
  },
  stTaxRates: {
    term: "CG ST Tax Rates",
    definition:
      "Client's marginal tax rate applicable to the short term capital gains",
  },
  ltTaxRates: {
    term: "CG LT Tax Rates",
    definition:
      "Client's marginal tax rate applicable to the long term capital gains",
  },
  realizedStGains: {
    term: "YTD Realized ST Gains",
    definition:
      "At the time of transition, client's realized short term gains from all sources",
  },
  realizedLtGains: {
    term: "YTD Realized LT Gains",
    definition:
      "At the time of transition, client's realized long term gains from all sources",
  },
  averageMarketCap: {
    term: "Average Weighted Market Cap",
    definition:
      "Weighted average of asset market capitalization based on asset's position size in a given portfolio. Market capitalization of an asset is defined as the product of the market price and the total amount of a security outstanding and it represents the total market value of the security in the hands of its investors.",
  },
  betaToBenchmark: {
    term: "Beta to Benchmark",
    definition:
      "A measure of the portfolio's sensitivity to the systematic risk of the Strategy's benchmark portfolio.",
  },
  commonFactorRisk: {
    term: "Common Factor Risk",
    definition:
      "A common factor is a characteristic shared by a group of securities that influences the returns of those securities. Securities with similar characteristics exhibit similar return behavior, which may be distinct from the rest of the market. In a multi-factor risk model, the common factors determine correlations between asset returns. Examples of common factors are industries, styles, term structure, and spreads.",
  },
  country: {
    term: "Country",
    definition:
      "Country of risk exposure for most assets, including equities. Country of quotation (the listing country) for ADRs. Country of issuance for fixed income assets, or country of borrower if available. Country associated with the currency for unit exposure assets. (For underliers with multiple country exposures, e.g., composites, this is returned as “XXX.”)",
  },
  defensive: {
    term: "Defensive, Highly Cyclical, and Moderately Cyclical sectors",
    definition:
      "Equity securities are classified based on economic sensitivity of its GICS categorization. Defensive Sectors include Consumer Staples, Healthcare, and Utilities sectors; Highly Cyclical sectors include Materials, Consumer Discretionary, Financials, and Real Estate; Moderately Cyclical sectors include Energy, Industrials, Information Technology, and Communication Services.",
  },
  dividend: {
    term: "Dividend Yield",
    definition:
      "A measure of yield using the trailing twelve months of dividends and the market price of the stock.",
  },
  gics: {
    term: `GICS${String.fromCharCode(174)}`,
    definition: `Global Industry Classification Standard (GICS${String.fromCharCode(
      174
    )}) - the GICS${String.fromCharCode(
      174
    )} scheme is hierarchical, with 10 sectors at the top level, 24 industry groups at the next level, followed with increasing granularity at the industry and sub-industry levels. GICS${String.fromCharCode(
      174
    )} applies a consistent global methodology to classify stocks based on evaluation of the firm’s business model and economic operating environment`,
  },
  caps: {
    term: "Large Cap, Mid Cap, and Small Cap",
    definition:
      "Size categorization are provided based on market capitalization for each equity security in the US.‘Large Cap’ - $15 billion or more , ‘Mid Cap’ - between $15 billion and $500 million, and ‘Small Cap’ – less than $500 million",
  },
  sectorRisk: {
    term: "Sector Risk",
    definition: `The part of common factor risk due to exposure to GICS${String.fromCharCode(
      174
    )} sectors.`,
  },
  specificRisk: {
    term: "Specific Risk",
    definition:
      "Risk that is specific to an asset and is uncorrelated (or negligibly correlated) with the risks of other assets. That is, asset specific risk is the portion of an asset’s or portfolio’s risk that is unexplained by the common factor risk model. Also called specific, unique, idiosyncratic, or independent risk.",
  },
  styleRisk: {
    term: "Style Risk",
    definition:
      "The part of common factor risk due to exposure to style factors, a risk factor that characterizes an equity’s fundamental or market-based characteristics such as Size, Value, Momentum, and Volatility.",
  },
  trackingErrorBenchmark: {
    term: "Tracking Error to Benchmark",
    definition:
      "A measure of the standard deviation of a portfolio's performance relative to the performance (excess return) of Strategy's benchmark portfolio.",
  },
  totalRisk: {
    term: "Total Risk",
    definition:
      "The total (gross) risk to an asset, which is the standard deviation of the asset’s total return distribution, expressed in percent. We forecast total risk using a multi-factor risk model. The total risk for an asset depends on the asset’s exposures to the common risk factors, the factor variance/covariance matrix, and the specific risk of the asset.",
  },
  usBeta: {
    term: "US Beta",
    definition:
      "Captures market risk that cannot be explained by the World factor. The Beta factor is typically the most important style factor. Beta is computed by time-series regression of excess stock returns against the cap-weighted estimation universe.",
  },
  usDividendYield: {
    term: "US Dividend Yield",
    definition:
      "Captures differences in stock returns attributable to stock's trailing 12-month and predicted dividend-to-price ratios",
  },
  usEarningsQuality: {
    term: "US Earnings Quality",
    definition:
      "Explains stock return differences due to the accrual components of earnings.",
  },
  usEarningsYield: {
    term: "US Earnings Yield",
    definition:
      "Describes return differences based on a company’s earnings relative to its price. Earnings Yield is considered by many investors to be a strong value signal. The most important descriptor in this factor is the analyst-predicted 12-month earnings-to-price ratio.",
  },
  usEarningsVariability: {
    term: "US Earnings Variability",
    definition:
      "Measures the variability in earnings and cash flows using both historical measures and analyst predictions",
  },
  usGrowth: {
    term: "US Growth",
    definition:
      "Differentiates stocks based on their prospects for sales or earnings growth. The most important descriptor in this factor is the analyst predicted long-term earnings growth. Other descriptors include sales and earnings growth over the trailing five years.",
  },
  usLiquidity: {
    term: "US Liquidity",
    definition:
      "Describes return differences due to relative trading activity. The descriptors for this factor are based on the fraction of total shares outstanding that trade over a recent window.",
  },
  usLeverage: {
    term: "US Leverage",
    definition:
      "Captures return differences between high-leverage and low-leverage stocks. The descriptors within this style factor include market leverage, book leverage, and debt-to-assets ratio",
  },
  usLongTermReversal: {
    term: "US Long-Term Reversal",
    definition:
      "Explains common variation in returns related to long-term stock price behavior",
  },
  usManagementQuality: {
    term: "US Management Quality",
    definition:
      "A combination of asset, investment, net issuance growth measures that captures variation in stock returns of companies experiencing growth or contraction of assets.",
  },
  usMidCapitalization: {
    term: "US Mid Capitalization",
    definition:
      "Explains differences in risk and return for mid-capitalization stocks from small-cap and large-cap stocks.",
  },
  usMomentum: {
    term: "US Momentum",
    definition:
      "Differentiates stocks based on their performance over the trailing 12 months. When computing Momentum exposures we exclude the most recent returns in order to avoid the effects of short-term reversal. The Momentum factor is often the second strongest factor in the model, although sometimes it may surpass Beta in importance.",
  },
  usProfitability: {
    term: "US Profitability",
    definition:
      "Combines profitability measures that characterize efficiency of a firm's operations and total activities",
  },
  usProspect: {
    term: "US Prospect",
    definition:
      "Explains variation in stock returns that have exhibited a lottery-like behavior identified through stock return skewness over a long horizon and drawdown in returns over the recent period.",
  },
  usResidualVolatility: {
    term: "US Residual Volatility",
    definition:
      "Captures relative volatility in stock returns that is not explained by Country and Beta factors",
  },
  usSize: {
    term: "US Size",
    definition:
      "Represents another strong source of equity return covariance, and captures return differences between large-cap stocks and small-cap stocks. We measure Size by the log of market capitalization.",
  },
  usValue: {
    term: "US Value",
    definition:
      "Captures the extent a company is overpriced or underpriced using relative and structural valuation metrics.",
  },
  russellIndex: {
    term: `Russell 1000 ${String.fromCharCode(174)} Index`,
    definition: `The Russell 1000 ${String.fromCharCode(
      174
    )} Index measures the performance of the 1,000 largest companies in the Russell 3000${String.fromCharCode(
      174
    )} Index, which represents approximately 92% of the total market capitalization of the Russell 3000 Index. You cannot invest directly in an index.`,
  },
  russellGrowthIndex: {
    term: `Russell 1000 ${String.fromCharCode(174)} Growth Index`,
    definition: `The Russell 1000 ${String.fromCharCode(
      174
    )} Growth Index measures the performance of those Russell 1000 companies with higher price/book ratios and higher forecasted growth values. You cannot invest directly in an index`,
  },
  russellValueIndex: {
    term: `Russell 1000 ${String.fromCharCode(174)} Value Index`,
    definition: `The Russell 1000 ${String.fromCharCode(
      174
    )} Value Index measures the performance of those Russell 1000 companies with lower price/book ratios and lower forecasted growth values. You cannot invest directly in an index.`,
  },
  standardAndPoors500IndexSAndP500Index: {
    term: `Standard & Poor's 500 Index (S&P 500 Index)`,
    definition: `The S&P 500 Index consists of 500 stocks chosen for market size, liquidity, and industry group representation. It is a market-value-weighted index with each stock's weight in the index proportionate to its market value. You cannot invest directly in an index.`,
  },
  benchmarkIndex: {
    term: "Benchmark S&P 500 Index",
    definition:
      "The S&P 500 Index consists of 500 stocks chosen for market size, liquidity, and industry group representation. It is a market-value-weighted index with each stock's weight in the index proportionate to its market value. You cannot invest directly in an index.",
  },
  note: "Allspring views the Minimize Tax Liability and Minimize Tracking Error portfolios as the end points of a spectrum of alternative portfolios*. The Minimize Tax Liability portfolio represents the alternative having the minimum tax liability, but the greatest risk. The Minimize Tracking Error portfolio represents the alternative having the minimum risk, but the maximum tax liability. Allspring stands ready to implement any portfolio between the Minimize Tax Liability portfolio and the Minimize Tracking Error portfolio that suits the prospective client's aversion to taxes and tolerance for risk. Allspring recommends the Balance Tax Liability & Tracking Error portfolio, which lies somewhere in the middle of the spectrum and represents a reasonable trade-off between tax liability and risk.",
  footnote:
    "For Investment Professional Use Only In One-On-One Presentation With Client",
};

export const cashCorpDefinitions = {
  model: {
    term: "Model",
    definition:
      "The Model Portfolio consists of securities pre-selected to achieve certain characteristics with a corresponding risk which is representative of the strategy. This portfolio is not guaranteed to be investable and is not actively managed.",
  },
  parValue: {
    term: "Par Value",
    definition:
      "Par Value Money amount the bond will be worth at maturity and the reference notional amount the bond issuer uses when calculating interest payments.",
  },
  price: {
    term: "Price",
    definition:
      "Price at which the buyer purchases the bond, including accrued interest.",
  },
};
